import React from 'react';
import { dateToTimezone } from './../../../utils';

const Table = React.memo((props) => {
    const redirectToFavorite = (url) => {
        props.history.push(url);
    };

    const handleDeleteFavorite = (id) => {
        props.deleteFavorite(id);
    };

    const renderItems = () => {
        if (props.fetching) {
            return <tr><td colSpan="6"><i className="fas fa-circle-notch fa-spin" /> Loading data...</td></tr>;
        }

        if (props.favorites.length === 0) {
            return <tr><td colSpan="6">Your Favorites list is empty</td></tr>;
        }

        return props.favorites.map((favorite) => {
            let previewImage = null;
            if (favorite.preview_image_url != null) {
                previewImage = <img src={favorite.preview_image_url} alt="UTP/UTH" />
            }

            return (
                <tr key={favorite.id}>
                    <td className="delete-column">
                        <i className="fas fa-trash" onClick={handleDeleteFavorite.bind(this, favorite.id)} />
                    </td>
                    <td className="preview-image-column">{previewImage}</td>
                    <td className="product-type-column">{favorite.product_type_name}</td>
                    <td className="product-name-column">{favorite.product_name}</td>
                    <td className="added-date-column">{dateToTimezone(favorite.created_at, 'MM/DD/YYYY')}</td>
                    <td className="actions-column">
                        <button type="button" className="view-product-button" onClick={redirectToFavorite.bind(this, favorite.url)}>View Product</button>
                    </td>
                </tr>
            );
        });
    };

    return (
        <div className="table-container">
            <table className="table">
                <thead>
                    <tr>
                        <th className="delete-column"></th>
                        <th className="preview-image-column"></th>
                        <th className="product-type-column">Product Type</th>
                        <th className="product-name-column">Product Name</th>
                        <th className="added-date-column">Date Added</th>
                        <th className="actions-column"></th>
                    </tr>
                </thead>
                <tbody>
                    {renderItems()}
                </tbody>
            </table>
        </div>
    );
});

export default Table;
